import { render, staticRenderFns } from "./ReceptionSearch.vue?vue&type=template&id=6dc10fa2&scoped=true"
import script from "./ReceptionSearch.vue?vue&type=script&lang=js"
export * from "./ReceptionSearch.vue?vue&type=script&lang=js"
import style0 from "./ReceptionSearch.vue?vue&type=style&index=0&id=6dc10fa2&prod&scoped=true&lang=css"
import style1 from "./ReceptionSearch.vue?vue&type=style&index=1&id=6dc10fa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc10fa2",
  null
  
)

export default component.exports